<template>
  <div class="dashboard">
    <div
      v-if="showDashboardFilters"
      class="d-flex align-items-center justify-content-between"
    >
      <div class="mb-3">
        <slot name="breadcrumb">
          <a
            v-if="back"
            :href="back"
            class="text-body text-decoration-none"
          >
            <i class="fa fa-arrow-left mr-1"></i>
            Back
          </a>
        </slot>
      </div>
      <div class="mb-3">
        <button
          v-if="!openFilters"
          class="btn btn-white"
          @click.prevent="toggleFilters"
        >
          <i class="fa fa-sliders"></i>
          <span class="d-none d-md-inline ml-1">
            Edit Filters
          </span>
        </button>
      </div>
    </div>
    <filters
      id="filters"
      v-if="showDashboardFilters"
      :open="openFilters"
      :filters="filters"
      :initial-values="filterValues"
      @toggle="toggleFilters"
      @apply="applyFilters"
    ></filters>
    <slot></slot>
    <modals></modals>
  </div>
</template>

<style lang="scss" scoped>
  /* I hid this when I realized it was messing up nav-pills; can't remember what it was intended to affect
.nav .nav-item .nav-link {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  color: #111;
}
*/
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { merge } from 'lodash'
import { EventBus } from '@/lib/event-bus'
import Filters from '@/components/dashboard/Filters'
import Modals from '@/components/dashboard/Modals'
import $ from 'jquery'

export default {
  components: {
    Filters,
    Modals
  },

  props: {
    showDashboardFilters: {
      type: Boolean,
      default: true
    },

    // Current dashboard
    dashboard: {
      type: Object,
      default () {
        return {}
      }
    },

    back: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      tabs: [],
      openFilters: false
    }
  },

  computed: {
    ...mapGetters('dashboard', [
      'filters',
      'filterValues',
      'dashboardFilter'
    ])
  },

  watch: {

  },

  mounted () {
    this.$on('filters.show', (filters) => {
      $('html, body').animate({ scrollTop: 0 });
      this.openFilters = true
    })

    this.updateNavigationURLs();

    $(this.$el).on('click', (e) => {
      let json = $(e.target).attr('data-show-modal')
      if (json) {
        let modal = JSON.parse(json)
        if (typeof modal !== typeof undefined && modal !== false) {
          e.preventDefault()
          this.showModal({
            id: modal.id,
            config: merge(
              modal.config,
              {
                visible: true
              }
            ),
            widgets: modal.widgets
          })
          return false
        }
      }
    })
  },

  methods: {
    ...mapMutations('dashboard', [
      'updateFilterValues',
      'showModal',
    ]),

    toggleFilters () {
      this.openFilters = !this.openFilters
    },

    applyFilters (values) {
      this.updateFilterValues(values)
      this.updateNavigationURLs()
      EventBus.$emit('updated-filters')
    },

    updateNavigationURLs(){
      if(this.dashboardFilter){
        $('.is-dashboard-link').map((index, link) => {
          let linkObj = $(link);
          let url = new URL(linkObj.attr('href'));
          url.search = 'filter='+this.dashboardFilter;
          return linkObj.attr('href', url.href);
        })
      }
    }
  }
}
</script>
